<div class="item-grid-container">
  <mat-card class="shadow">
    <div class="carrier-promotions-form">
      <form
        [formGroup]="consumerPromotionForm"
        (ngSubmit)="onCarrierFormSubmit($event)"
      >
        <div class="form-inner buss-info-details content-details-blk">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div class="row mb-0">
                <div
                  class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label mb-0">
                    {{ "pages.ConsumerPromotions.PromotionHeader" | translate
                    }}<span class="required">*</span>
                  </h4>
                </div>
                <div
                  class="col-lg-9 col-md-9 col-sm-9 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        type="text"
                        formControlName="promotionHeader"
                        placeholder="{{
                          'pages.ConsumerPromotions.PromotionHeader' | translate
                        }}"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row mb-0">
                <div
                  class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label mb-0">
                    {{
                      "pages.PromotionCarrierPromotions.PromotionName"
                        | translate
                    }}
                  </h4>
                </div>
                <div
                  class="col-lg-9 col-md-9 col-sm-9 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        type="text"
                        formControlName="promotionName"
                        placeholder="{{
                          'pages.PromotionCarrierPromotions.PromotionName'
                            | translate
                        }}"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row mb-0">
                <div
                  class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-start mt-2"
                >
                  <h4 class="form-item-label mb-0">
                    {{
                      "pages.ConsumerPromotions.PromotionDescription"
                        | translate
                    }}<span class="required">*</span>
                  </h4>
                </div>
                <div
                  class="col-lg-9 col-md-9 col-sm-9 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <textarea
                        matInput
                        type="text"
                        formControlName="promotionDescription"
                        placeholder="{{
                          'pages.ConsumerPromotions.PromotionDescription'
                            | translate
                        }}"
                      ></textarea>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row mb-0">
                <div
                  class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label mb-0">
                    {{ "pages.placeholders.PromotionNameText" | translate }}
                  </h4>
                </div>
                <div
                  class="col-lg-9 col-md-9 col-sm-9 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        type="text"
                        formControlName="promotionNameText"
                        placeholder="{{
                          'pages.placeholders.PromotionNameText' | translate
                        }}"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row mb-0">
                <div
                  class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label mb-0">
                    {{
                      "pages.placeholders.PromotionDescriptionText" | translate
                    }}
                  </h4>
                </div>
                <div
                  class="col-lg-9 col-md-9 col-sm-9 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <textarea
                        matInput
                        type="text"
                        formControlName="promotionDescriptionText"
                        placeholder="{{
                          'pages.placeholders.PromotionDescriptionText'
                            | translate
                        }}"
                      ></textarea>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row mb-0">
                <div
                  class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label mb-0">
                    {{ "pages.placeholders.PromotionNameApp" | translate
                    }}<span class="required">*</span>
                  </h4>
                </div>
                <div
                  class="col-lg-9 col-md-9 col-sm-9 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        type="text"
                        formControlName="promotionNameApp"
                        placeholder="{{
                          'pages.placeholders.PromotionNameApp' | translate
                        }}"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row mb-0">
                <div
                  class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label mb-0">
                    {{ "pages.placeholders.PromotionDescriptionApp" | translate
                    }}<span class="required">*</span>
                  </h4>
                </div>
                <div
                  class="col-lg-9 col-md-9 col-sm-9 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <textarea
                        matInput
                        type="text"
                        formControlName="promotionDescriptionApp"
                        placeholder="{{
                          'pages.placeholders.PromotionDescriptionApp'
                            | translate
                        }}"
                      ></textarea>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label mb-0">
                    {{ "pages.placeholders.AdditionalInformation" | translate }}
                  </h4>
                </div>
                <div
                  class="col-lg-9 col-md-9 col-sm-9 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <textarea
                        matInput
                        type="text"
                        formControlName="additionalInfo"
                        placeholder="{{
                          'pages.placeholders.AdditionalInformation' | translate
                        }}"
                      ></textarea>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label mb-0">
                {{ "pages.Promocodehistory.Validity" | translate
                }}<span class="required">*</span>
              </h4>
            </div>

            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="row">
                <div class="col-12 col-xs-12 col-sm-6">
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        [matDatepicker]="picker"
                        formControlName="promotionStartdttm"
                        placeholder="{{
                          'pages.Creditlinereport.From' | translate
                        }}"
                      />
                      <!-- <span matPrefix>{{'pages.Creditlinereport.From' | translate }}</span> -->
                      <mat-datepicker-toggle matSuffix [for]="picker">
                        <mat-icon matDatepickerToggleIcon
                          >keyboard_arrow_down</mat-icon
                        >
                      </mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-12 col-xs-12 col-sm-6">
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        [matDatepicker]="picker1"
                        formControlName="promotionEnddttm"
                        placeholder="{{
                          'pages.Creditlinereport.To' | translate
                        }}"
                        [min]="
                          consumerPromotionForm.controls['promotionStartdttm']
                            .value
                        "
                      />
                      <mat-datepicker-toggle matSuffix [for]="picker1">
                        <mat-icon matDatepickerToggleIcon
                          >keyboard_arrow_down</mat-icon
                        >
                      </mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label mb-0">
                {{ "pages.newRetailer.amount" | translate
                }}<span class="required">*</span>
              </h4>
            </div>

            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="row">
                <div class="col-12 col-xs-12 col-sm-6">
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        formControlName="applicableMinAmount"
                        placeholder="{{ 'pages.placeholders.Min' | translate }}"
                      />
                      <!--<span matPrefix>$</span>-->
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-12 col-xs-12 col-sm-6">
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        formControlName="applicableMaxAmount"
                        placeholder="{{ 'pages.placeholders.Max' | translate }}"
                      />
                      <!--<span matPrefix>$</span>-->
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label mb-0">
                {{ "pages.placeholders.MinTopUpAmount" | translate }}
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    formControlName="minTopUpAmount"
                    placeholder="{{
                      'pages.placeholders.MinTopUpAmount' | translate
                    }}"
                  />
                  <!--<span matPrefix>$</span>-->
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label mb-0">
                {{ "pages.placeholders.VendorName" | translate }}
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    formControlName="vendorName"
                    placeholder="{{
                      'pages.placeholders.VendorName' | translate
                    }}"
                  />
                  <!-- <span matPrefix>$</span> -->
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label mb-0">Video URL</h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    formControlName="videoUrl"
                    placeholder="Video URL"
                  />
                  <!--<span matPrefix>$</span>-->
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label mb-0">
                Choose Image <span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <input
                  type="file"
                  id="file"
                  class="upload-container mt-3"
                  accept=".jpg, .jpeg, .png"
                  (change)="handleFileInput($event.target.files)"
                />
                <!-- <span matPrefix>$</span> -->
              </div>
            </div>
          </div>
          <h5 class="content-label-each mt-4 mb-4">
            {{ "pages.placeholders.MapPromotionToTilaProduct" | translate }}
          </h5>
          <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label mb-0">
                {{ "pages.Promocodehistory.CodeGroup" | translate
                }}<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-select
                    formControlName="tilaCodeGroup"
                    placeholder="{{
                      'pages.placeholders.SelectCodeGroup' | translate
                    }}"
                    (selectionChange)="getCountries($event)"
                  >
                    <mat-option
                      *ngFor="let codeGroup of codeGroups"
                      [value]="codeGroup"
                    >
                      {{ codeGroup }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label mb-0">
                {{ "pages.Promocodehistory.Country" | translate
                }}<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-select
                    formControlName="tilaCountry"
                    placeholder="{{
                      'pages.placeholders.SelectCountry' | translate
                    }}"
                    (selectionChange)="getCarriersList($event)"
                  >
                    <mat-option
                      *ngFor="let country of serviceCountries"
                      [value]="country"
                    >
                      {{ country }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label mb-0">
                {{ "pages.Promocodehistory.Carrier" | translate
                }}<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-select
                    formControlName="tilaCarrier"
                    placeholder="{{
                      'pages.placeholders.Selectcarrier' | translate
                    }}"
                    (selectionChange)="getsku($event)"
                  >
                    <mat-option
                      *ngFor="let promotionsCarrier of promotionsCarriers"
                      [value]="promotionsCarrier"
                    >
                      {{ promotionsCarrier }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label mb-0">
                {{ "pages.ManageProducts.Productname" | translate
                }}<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <!-- {{ skulist |json  }} -->
                <mat-form-field appearance="outline" class="w-100">
                  <mat-select
                    formControlName="tilaProductId"
                    placeholder="{{
                      'pages.placeholders.SelectProduct' | translate
                    }}"
                  >
                    <mat-option
                      *ngFor="let sku of skulist"
                      [value]="sku?.productId"
                    >
                      {{ sku?.productName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="row">
              <div class="col-12">
                <mat-checkbox
                  color="primary"
                  formControlName="isCertified"
                  (change)="onCheckCertify($event)"
                  class="is-certified"
                  >{{
                    "pages.placeholders.CertifyPromotion" | translate
                  }}</mat-checkbox
                >
              </div>
            </div>
          </div>
          <div class="form-footer text-center">
            <button
              mat-raised-button
              color="primary"
              type="submit"
              [disabled]="consumerPromotionForm.invalid"
            >
              {{ "pages.placeholders.SavePromotion" | translate }}
            </button>
            <button
              mat-stroked-button
              color="primary"
              type="button"
              (click)="onCancel()"
            >
              <span translate class="translate">pages.newRetailer.cancel</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </mat-card>
</div>
